import { APPEALS_ANCHORS, APPEALS_CONTEXTS } from './anchors'
import { SHARED_ANCHORS } from '../shared/anchors'
import { taskCardSteps } from '../shared/steps'
import { withScopes } from '../shared/scopes'
import type { IOnboardingScenario } from '../../types/IOnboardingScenario'
import type { IOnboardingScope } from '../../types/IOnboardingScope'
import type { IOnboardingStep } from '../../types/IOnboardingStep'

const { nav, table, settings, form } = APPEALS_ANCHORS
const { ear } = SHARED_ANCHORS
const ctx = APPEALS_CONTEXTS

/*
 * Области реестра:
 * - actionsMenu — раскрытое «Меню действий» на мобильном (на десктопе действие ничего не делает);
 * - settingsPage — страница настроек модуля (вкладка «Каналы»).
 */
const tableScopes: Record<string, IOnboardingScope> = {
  actionsMenu: { open: { context: ctx.table, action: 'openActionsMenu' } },
  settingsPage: {
    open: { context: ctx.table, action: 'openSettings' },
    close: { context: ctx.settings, action: 'backToAppeals' },
  },
}

const tableSteps: IOnboardingStep[] = [
  { id: 'appeals.intro', anchors: [], context: ctx.table },
  { id: 'appeals.create', anchors: [table.create], context: ctx.table },
  ...withScopes(['actionsMenu'], [
    { id: 'appeals.qr', anchors: [table.qr], context: ctx.table },
    { id: 'appeals.settings', anchors: [table.settings], context: ctx.table, condition: 'appeals.canSettings' },
  ]),
  ...withScopes(['settingsPage'], [
    { id: 'appeals.settings.channels', anchors: [settings.channels], context: ctx.settings, condition: 'appeals.canSettings', placement: 'bottom' },
    { id: 'appeals.settings.addChannel', anchors: [settings.addChannel], context: ctx.settings, condition: 'appeals.canSettings' },
  ]),
  { id: 'appeals.navSettings', anchors: [nav.settings], context: ctx.table, condition: 'appeals.canSettings', placement: 'right' },
  ...withScopes(['actionsMenu'], [
    { id: 'toolbar.reports', anchors: [SHARED_ANCHORS.toolbar.reports], context: ctx.table },
    { id: 'toolbar.onboarding', anchors: [SHARED_ANCHORS.toolbar.onboarding], context: ctx.table },
  ]),
  { id: 'appeals.search', anchors: [table.search], context: ctx.table },
  { id: 'appeals.filters', anchors: [table.filterFirst, table.filterLast], context: ctx.table },
  { id: 'appeals.resetFilters', anchors: [table.resetFilters], context: ctx.table },
  { id: 'appeals.hideAnswered', anchors: [table.hideAnswered], context: ctx.table },
  { id: 'appeals.demoRow', anchors: [table.demoRow], context: ctx.table },
]

/*
 * Области формы одинаковы в обоих сценариях, отличается только то, как открывается сама форма.
 * Чата у обращения нет, поэтому общий фрагмент «ушек» не подходит — свой шаг документа и ссылки.
 */
const formSteps: IOnboardingStep[] = [
  ...withScopes(['form'], [
    { id: 'appeals.form.channelTopic', anchors: [form.channelTopic], context: ctx.form },
    { id: 'appeals.form.rating', anchors: [form.rating], context: ctx.form },
    { id: 'appeals.form.applicant', anchors: [form.applicant, form.contacts], context: ctx.form },
    { id: 'appeals.form.target', anchors: [form.target], context: ctx.form },
    { id: 'appeals.form.text', anchors: [form.text], context: ctx.form },
    { id: 'appeals.form.reply', anchors: [form.reply], context: ctx.form },
    { id: 'appeals.form.tasksEar', anchors: [ear.tasks], context: ctx.form, placement: 'left' },
  ]),
  ...withScopes(['form', 'tasksPane'], [
    { id: 'appeals.form.assignCoordinator', anchors: [form.assignCoordinator], context: ctx.formTasks, placement: 'left' },
    ...taskCardSteps(ctx.formTasks),
  ]),
  ...withScopes(['form'], [
    { id: 'appeals.form.ears', anchors: [ear.reports, ear.link], context: ctx.form, placement: 'left' },
    { id: 'ear.onboarding', anchors: [ear.onboarding], context: ctx.form, placement: 'left' },
  ]),
]

const tasksPaneScope: IOnboardingScope = {
  open: { context: ctx.formTasks, action: 'openTasksPane' },
  close: { context: ctx.formTasks, action: 'closeTasksPane' },
}

export const appealsScenarios: IOnboardingScenario[] = [
  {
    id: 'appeals',
    section: 'appeal',
    isMain: true,
    scopes: {
      ...tableScopes,
      form: {
        open: { context: ctx.table, action: 'openDemoForm' },
        close: { context: ctx.table, action: 'closeForm' },
      },
      tasksPane: tasksPaneScope,
    },
    steps: [...tableSteps, ...formSteps],
  },
  {
    id: 'appeals.form',
    section: 'appeal',
    isMain: false,
    scopes: {
      form: {
        open: { context: ctx.form, action: 'showDemo' },
        close: { context: ctx.form, action: 'showReal' },
      },
      tasksPane: tasksPaneScope,
    },
    steps: formSteps,
  },
]
